import { Button } from '@ds';
import { ButtonStyle } from '@ds/elements/Button/Button.types';
import styles from './RemoteInfoBanner.module.scss';

interface RemoteInfoBannerProps {
  title: string;
  buttonInfo: { text: string; disabled?: boolean; onClick: () => void };
}

const RemoteInfoBanner = (props: RemoteInfoBannerProps) => {
  const { title, buttonInfo } = props;
  return (
    <div className={styles['remote-info-banner']}>
      <p>{title}</p>
      <Button styleType={ButtonStyle.secondary} disabled={buttonInfo.disabled} onClick={buttonInfo.onClick}>
        {buttonInfo.text}
      </Button>
    </div>
  );
};

export default RemoteInfoBanner;
